import React from 'react';
import { motion } from 'framer-motion';
export function Proof() {
  return <section className="py-20 bg-mint text-navy" data-id="element-117">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-119">
          <p className="text-xl md:text-2xl font-medium leading-relaxed mb-8" data-id="element-120">
            Este método ha sido estructurado para pasar de un estado de
            confusión y fatiga a uno de{' '}
            <span className="font-bold" data-id="element-121">enfoque láser</span> en solo{' '}
            <span className="font-bold" data-id="element-122">2 días</span>.
          </p>
          <p className="text-lg md:text-xl text-navy/80 mb-8" data-id="element-123">
            No es una teoría larga; es un manual de aplicación inmediata para
            personas que no tienen tiempo que perder.
          </p>
          <div className="inline-block bg-white/50 backdrop-blur-sm px-6 py-3 rounded-full font-bold text-navy border border-navy/10" data-id="element-124">
            Verás cambios en tu nivel de alerta desde la primera mañana.
          </div>
        </motion.div>
      </div>
    </section>;
}